import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// Sidebar otevřeno/zavřeno i "auto/uživatel" režim se pamatují přes
// reload/relaci (2026-08-23, na přání uživatele - "pamatovat si, že sidebar
// uživatel stáhnul do úzkého"). 'auto' = šířka sidebaru se dál řídí šířkou
// okna (Dashboard/index.jsx's downXL efekt, původní chování); 'user' = ten
// efekt se přestane pletl do stavu, sidebar zůstane přesně tak, jak si ho
// uživatel ručně nastavil, i po zmenšení okna.
const DRAWER_OPEN_KEY = 'dora-sidebar-open';
const SIDEBAR_MODE_KEY = 'dora-sidebar-mode';

function readStoredDrawerOpen(fallback) {
  try {
    const raw = localStorage.getItem(DRAWER_OPEN_KEY);
    return raw === null ? fallback : raw === 'true';
  } catch {
    return fallback;
  }
}

function readStoredSidebarMode() {
  try {
    return localStorage.getItem(SIDEBAR_MODE_KEY) === 'user' ? 'user' : 'auto';
  } catch {
    return 'auto';
  }
}

const initialState = {
  isDashboardDrawerOpened: readStoredDrawerOpen(false),
  sidebarMode: readStoredSidebarMode()
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  // to update local state based on key
  try {
    localStorage.setItem(DRAWER_OPEN_KEY, String(isDashboardDrawerOpened));
  } catch {
    // localStorage nedostupné (private mode apod.) - stav se prostě
    // nezapamatuje přes reload, appka dál funguje beze změny.
  }

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}

export function handlerSidebarMode(sidebarMode) {
  try {
    localStorage.setItem(SIDEBAR_MODE_KEY, sidebarMode);
  } catch {
    // viz handlerDrawerOpen výše.
  }

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, sidebarMode };
    },
    false
  );
}
